import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import Api from '../../../services/Api';
import FileDropzone from '../../atoms/FileDropzone/FileDropzone';
import Icon from '../../atoms/Icon/Icon';
import './InstanceDocumentEditor.scss';

const InstanceDocumentEditor = ({
  onFilesChanged,
  initialDocuments,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [fileTypes, setFileTypes] = useState([]);
  const [dataTypeId, setDataTypeId] = useState(undefined);
  const [dataCode, setDataCode] = useState(undefined);
  const [uploadedFiles, setUploadedFiles] = useState(initialDocuments);
  const [uploadData, setUploadData] = useState({});
  useEffect(() => {
    setUploadData({
      document_type_id: dataTypeId,
      code: dataCode,
    });
  }, [dataTypeId, dataCode]);

  useEffect(() => {
    Api.get('types/data-types?per_page=200').then((response) => {
      if (response.status === 200) {
        setFileTypes(response.data.data);
      }
    });
  }, []);
  return (
    <>
      <Modal size="lg" show={isModalOpen} backdrop="static" keyboard={false}>
        <Modal.Header closeButton onHide={() => setIsModalOpen(prevState => !prevState)}>
          <Modal.Title>Add new file</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group>
              <Form.Label>Data Type</Form.Label>
              <Form.Select onChange={e => setDataTypeId(e.target.value)}>
                <option>---Select Data Type---</option>
                {fileTypes && fileTypes.length > 0 && (
                  fileTypes.map(type => (
                    <option value={type.id}>{`${type.name} [${type.code}]`}</option>
                  ))
                )}
              </Form.Select>
            </Form.Group>
            <br />
            <FileDropzone
              endpoint="documents/upload"
              onFilesChanged={(files) => {
                setIsModalOpen(false);
                setDataCode(undefined);
                setDataTypeId(undefined);
                const newFiles = [...uploadedFiles, ...files];
                setUploadedFiles(newFiles);
                if (onFilesChanged) {
                  onFilesChanged(newFiles);
                }
              }}
              additionalPostData={uploadData}
            />
          </Form>
        </Modal.Body>
      </Modal>
      <label>Files</label>
      {!uploadedFiles || uploadedFiles.length === 0 ? (
        <div className="instance-document-editor" onClick={() => setIsModalOpen(prevState => !prevState)}>
          <span>Select Document to Attach</span>
        </div>
      ) : (
        <div className="instance-document-viewer">
          <Table responsive hover striped>
            <colgroup>
              <col width="80%" />
              <col width="20%" />
            </colgroup>
            <thead>
              <tr>
                <th>File</th>
                <th>
                  <Icon icon="cogs" color="#000" />
                </th>
              </tr>
            </thead>
            <tbody>
              {uploadedFiles.map(file => (
                <tr>
                  <td>
                    <a href={file.url} target="_blank" rel="noreferrer">{file.name}</a>
                  </td>
                  <td>
                    <Button
                      variant="default"
                      onClick={() => {
                        const f = uploadedFiles.filter(x => x.id !== file.id);
                        setUploadedFiles(f);
                        if (onFilesChanged) {
                          onFilesChanged(f);
                        }
                      }}
                    >
                      <Icon icon="times" color="red" />
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
          <Button variant="default" onClick={() => setIsModalOpen(prevState => !prevState)}>
            <Icon icon="plus" />
            <span className="ms-2">Add More</span>
          </Button>
        </div>
      )}
    </>
  );
};

InstanceDocumentEditor.propTypes = {
  onFilesChanged: PropTypes.func.isRequired,
  initialDocuments: PropTypes.array,
};

InstanceDocumentEditor.defaultProps = {
  initialDocuments: [],
};

export default InstanceDocumentEditor;
